<template>
  <el-dialog title="Pré-postagem Finalzação" :append-to-body="false" center :visible.sync="dialog">
    <el-dialog title="Imprimir Etiquetas (10x15)" center :visible.sync="print.dialog" append-to-body>
      <el-form>
        <el-form-item>
          <el-radio v-model="print.model" label="0"
            >Zebra<br />
            <img src="/img/zebra4x1.png" style="margin-left: 23px"
          /></el-radio>
          <el-radio v-model="print.model" label="1"
            >1 por folha<br />
            <img src="/img/etiqueta4x1.png" style="margin-left: 28px"
          /></el-radio>
          <el-radio v-model="print.model" label="2"
            >2 por folha<br />
            <img src="/img/etiqueta4x2.png" style="margin-left: 28px"
          /></el-radio>
          <el-radio v-model="print.model" label="4"
            >4 por folha<br />
            <img src="/img/etiqueta4x4.png" style="margin-left: 28px"
          /></el-radio>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="print.warning" autocomplete="off">Imprimir Aviso Recebimento</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="print.declared" autocomplete="off">Imprimir Declaração Conteudo</el-checkbox>
          <el-radio :disabled="!print.declared" v-model="print.type" label="1">Para todas as etiquetas</el-radio>
          <el-radio :disabled="!print.declared" v-model="print.type" label="2">Somente que possuem declaração</el-radio>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="print.separator" autocomplete="off">Arquivos separados</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="print.dialog = false">Cancelar</el-button>
        <el-button type="primary" @click="doprintall">Imprimir</el-button>
      </span>
    </el-dialog>
    <el-card shadow="never">
      <el-steps :space="400" :active="2" simple :align-center="true">
        <el-step :title="source" icon="el-icon-office-building"></el-step>
        <el-step :title="destiny" icon="el-icon-s-home"></el-step>
      </el-steps>
      <p style="text-align: center; padding-top: 20px"><img :src="logo" width="120px" />&nbsp;<br /></p>
      <p style="text-align: center; padding-top: 20px">
        <span style="font-size: 30px">{{ tag }}</span>
        <i class="el-icon-document-copy tag-icon" style="cursor: pointer" v-clipboard:copy="tag" @click="copy()"></i>
      </p>
    </el-card>
    <span slot="footer" class="dialog-footer">
      <el-button type="success" @click.stop.prevent="print.dialog = true">Imprimir</el-button>
      <el-button type="default" @click.stop.prevent="dialog = false">OK</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { PrepostService } from "@/services/customers/prepost.services";
import moment from "moment";
import "moment/locale/pt-br";

export default {
  name: "PostFinished",
  data() {
    return {
      source: "",
      destiny: "",
      price: 0,
      service: "",
      tag: "",
      dialog: false,
      active: 1,
      logo: "/img/MaisEnvios_color.png",
      print: {
        model: "4",
        warning: true,
        declared: true,
        type: "1",
        dialog: false,
        separator: false,
      },
    };
  },
  methods: {
    doprintall() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      const tags = [vm.tag];
      if (vm.print.separator) {
        PrepostService.printSeparador(tags, vm.print)
          .then((response) => {
            vm.print.dialog = false;
            const today = moment();
            var downloadLink = document.createElement("a");
            downloadLink.href = response.data;
            downloadLink.download = `etiqueta-${tags.length}-${today.format("YYYY-MM-DD")}.pdf`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            if (response.declared) {
              var downloadLink = document.createElement("a");
              downloadLink.href = response.declared;
              downloadLink.download = `etiqueta-dc-${today.format("YYYY-MM-DD")}.pdf`;
              document.body.appendChild(downloadLink);
              downloadLink.click();
            }
            if (response.warning) {
              var downloadLink = document.createElement("a");
              downloadLink.href = response.warning;
              downloadLink.download = `etiqueta-ar-${today.format("YYYY-MM-DD")}.pdf`;
              document.body.appendChild(downloadLink);
              downloadLink.click();
            }
          })
          .catch((error) => {
            this.$message({
              type: "error",
              duration: 5000,
              message: error,
            });
          })
          .finally(() => loading.close());
      } else {
        PrepostService.print(tags, vm.print)
          .then((response) => {
            vm.print.dialog = false;
            const today = moment();
            var downloadLink = document.createElement("a");
            downloadLink.href = response;
            downloadLink.download = `etiqueta-${tags.length}-${today.format("YYYY-MM-DD")}.pdf`;
            document.body.appendChild(downloadLink);
            downloadLink.click();
          })
          .catch((error) => {
            this.$message({
              type: "error",
              duration: 5000,
              message: error,
            });
          })
          .finally(() => loading.close());
      }
    },
    copy() {
      this.$message({
        type: "success",
        message: "Objeto copiado com sucesso",
      });
    },
    open(data) {
      console.log("opem", data);
      this.source = data.sourcezipcode;
      this.destiny = data.destinyzipcode;
      this.price = +data.pricetable;
      this.service = data.service;
      this.tag = data.tag;
      this.dialog = true;
    },
  },
};
</script>

çll
